export default __webpack_public_path__ + "icons/mstile-70x70-05bf8be9e8aaa1f14605ab52c20ea45d.png";